/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_IncompleteInputs */

const en_us2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer the questions for every marked spot.`)
};

const pt_br2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda as perguntas de cada ponto marcado.`)
};

const es_419_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde las preguntas de cada punto marcado.`)
};

const pt_pt2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde às perguntas de cada ponto marcado.`)
};

const fr_fr2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponds aux questions pour chaque zone marquée.`)
};

const de_de2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte die Fragen für jede markierte Stelle.`)
};

const it_it2_bodymap_incomplete = /** @type {(inputs: Bodymap_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi alle domande per ogni punto segnato.`)
};

/**
* | output |
* | --- |
* | "Answer the questions for every marked spot." |
*
* @param {Bodymap_IncompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_incomplete = /** @type {((inputs?: Bodymap_IncompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_IncompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_incomplete(inputs)
	if (locale === "es-419") return es_419_bodymap_incomplete(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_incomplete(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_incomplete(inputs)
	if (locale === "de-DE") return de_de2_bodymap_incomplete(inputs)
	if (locale === "it-IT") return it_it2_bodymap_incomplete(inputs)
	return en_us2_bodymap_incomplete(inputs)
});
export { bodymap_incomplete as "bodymap.incomplete" }